import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ChangeTrackingCodeInput } from './ChangeTrackingCodeInput';
import { ChangeTrackingCodeOutput } from './ChangeTrackingCodeOutput';

export class ChangeTrackingCodeService extends HttpServiceBase {

  handle = (input: ChangeTrackingCodeInput): Promise<Result<ChangeTrackingCodeOutput> | null> => {
    const promise = this.http.post<Result<ChangeTrackingCodeOutput>, ChangeTrackingCodeInput>(`${this.baseUrlSislogApi}/v2/collect-tracking/tracking-code`, input);
    return promise;
  }
}